<template>
  <div>
    <div class="fullwidth">
      <div class="flex-start">
        <div style="flex-grow:2">
          <div class="exclusive">{{$nippets.exrep}}</div>
          <h1>{{ artist.formatted_name }}</h1>
        </div>
        <search-widget right v-if="!mobile"/>
      </div>
      <div class="flex-portfolio">
        <div class="pf-one-div">
          <portfolio-intro :artist="artist" v-on:changeRegion="changeRegion" v-on:load="loadedDetails" animation />
        </div>
        <div class="pf-rest-div">
          <portfolio-controls :artist="artist" :details="details" :mobile="mwidth < 1100" />
          <div class="pf-matrix">
            <template v-for="item in imageHolders">
              <zoom-animation :autoplay="item.autoplay" v-if="item.wide" :image="item.image" :artist="artist" inpage class="fwid" muted :key="item.image.image_id" />
              <portfolio-animation v-if="!item.wide" :key="item.image.image_id" :artist="artist" :image="item.image"
                v-on:zoom="handleZoom" />
            </template>
          </div>
        </div>
        <zoom-image :visible="showZoom" 
          v-on:prev="zoomImage(-1)" v-on:next="zoomImage(1)"
          :image="selImage" v-on:close="closeZoom" :artist="artist" />
      </div>
    </div>
    <testimonial-floater :artist="artist.portfolio_url" />
  </div>
</template>

<script>
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import PortfolioIntro from '@/components/panels/PortfolioIntro.vue'
import PortfolioControls from '@/components/panels/PortfolioControls.vue'
import PortfolioAnimation from '@/components/widgets/PortfolioAnimation.vue'
import ZoomImage from '@/components/panels/ZoomImage.vue'
import ZoomAnimation from '@/components/panels/ZoomAnimation.vue'
import TestimonialFloater from '@/components/panels/TestimonialFloater.vue'
import '@/css/portfolio.css'

import apix from '@/api.js'

export default {
  components:{
    SearchWidget,
    PortfolioIntro,
    PortfolioControls,
    PortfolioAnimation,
    ZoomImage,
    ZoomAnimation,
    TestimonialFloater
  },
  props: {
    name: String
  },
  data () {
    return {
      artist: { galleries: [], region: ''},
      subhead: '',
      images: [],
      imageHolders: [],
      selImage: null,
      showZoom: false,
      hero: null,
      details: {},
      mwidth: 1024
    }
  },
  computed: {
    mobile() {
      return this.mwidth <= 640
    }
  },
  created () {
    this.loadData()
  },
  mounted: function () {
    this.setUpSizing()
    window.addEventListener('resize', this.setUpSizing)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setUpSizing)
  },
  methods: {
    setUpSizing: function () {
      this.mwidth = window.innerWidth
    },
    loadedDetails (details) {
      this.details = details
    
      if(!details.meta_title) {
        details.meta_title = 'AnimationX - ' + this.artist.formatted_name
      }
      this.$k.setMetatags(details.meta_title, details.meta_description)
    },
    loadData: async function () {
      await this.$store.dispatch('fetchGalleries')
      this.artist = await this.$store.dispatch('fetchArtist', this.name)
      
      let res = this.$store.state.artistAnimations[this.artist.artist_id]
      if(!res) {
        res = await apix.post('collections/images', { artist_id: Number(this.artist.artist_id) })
        
        res = res.data.filter(el => el.animation)
        res.sort((el, el1) => { return el.order - el1.order})
        res = res.slice(0,40)
        this.$store.commit('setArtistAnimations', { id: this.artist.artist_id, data: res })
      }
      console.log('animations is ', res)
      this.images = res
      let ctr = 0
      let arr = []
      let autoplay = true
      for(let i = 0; i < res.length; i++)
      {
        let wide = false
        if(ctr == 0) {
          if(this.$k.canHaveClip(res[i].swf)){
            wide = true
            ctr += 1
          }
        }
        arr.push({wide: wide, image: res[i], autoplay: autoplay})
        if(wide) {
          autoplay = false
        }
        ctr += 1
        if(ctr == 4) ctr = 0
      }
      this.imageHolders = arr
    },
    changeRegion: async function (region) {
      this.$store.commit('setAzLocation', region)
      this.$ixr.push('/animators')
    },
    handleZoom: async function (image) {
      this.selImage = image
      this.showZoom = true
    },
    closeZoom: async function () {
      this.mimage = {}
      this.showZoom = false
    },
    getCurrentPos: function () {
      if(!this.selImage.image_id) return -1
      return this.images.findIndex(el => el.image_id === this.selImage.image_id)
    },
    zoomImage: function (moveRel) {
      let pos = this.getCurrentPos()
      if(pos < 0) {
        pos = 0
      }
      else {
        pos += moveRel
        if(pos < 0) {
          pos = this.images.length - 1
        }
        else if (pos >= this.images.length) {
          pos = 0;
        }
      }
      this.selImage = this.images[pos]
    }
  },
  watch: {
    name () {
      this.loadData()
    }
  }

}
</script>

<style scoped>
h1{
  font-size:45px;
  font-weight:500;
  margin:0 0 16px 0;
}



.rest-div{
  flex-grow:1;
  min-height:400px;
}

.pf-matrix{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.pf-matrix .imdiv{
  width:49%;
  position: relative;
  margin-bottom:2%;
}


.pf-matrix .fwid{
  width:100%;
  height:auto;
  margin-bottom:2%;
}

</style>